import { create } from "zustand";

enum ENUMPOASteps {
  IDENTIFY = 0,
  EMAILANDPHONE = 1,
  POAINFO = 2,
  POADURATION = 3,
  POACONFIRMATION = 4,
  POASIGN = 5,
  BOOKMEETING = 6,
  POASUMMARY = 7,
}

type State = {
  currentStep: ENUMPOASteps;
};

type Actions = {
  setStep: (step: ENUMPOASteps) => void;
  nextStep: () => void;
  prevStep: () => void;
};

type POAStepsStore = State & Actions;

const usePOAStepsStore = create<POAStepsStore>((set) => ({
  currentStep: ENUMPOASteps.IDENTIFY,
  setStep: (step) => set({ currentStep: step }),
  nextStep: () => set((state) => ({ currentStep: state.currentStep + 1 })),
  prevStep: () => set((state) => ({ currentStep: state.currentStep - 1 })),
}));

export { usePOAStepsStore, ENUMPOASteps };
